import { createContext, useContext } from 'react';

/** Chữ cái đầu của tối đa hai từ cuối ("Nguyễn Văn An" → "VA"). */
export function initials(name: string): string {
  return name
    .trim()
    .split(/\s+/)
    .slice(-2)
    .map((w) => w[0]?.toUpperCase() ?? '')
    .join('');
}

/** Chọn một trong 5 sắc avatar theo chuỗi (ổn định giữa các lần render). */
export function avatarTone(seed: string): number {
  let h = 0;
  for (const ch of seed) h = (h * 31 + ch.codePointAt(0)!) >>> 0;
  return h % 5;
}

/** base64url (WebP) → data URL (data URL cần base64 chuẩn, có padding). */
export function avatarDataUrl(b64url: string): string {
  const std = b64url.replace(/-/g, '+').replace(/_/g, '/');
  return `data:image/webp;base64,${std}${'='.repeat((4 - (std.length % 4)) % 4)}`;
}

/**
 * Tra ảnh theo `seed` (id người dùng / bot / hội thoại): ứng dụng cấp hàm tra qua `AvatarSrcProvider` để mọi chỗ đang vẽ
 * `<Avatar seed=…>` tự hiện ảnh khi có, không phải sửa từng chỗ dùng. Không có ảnh → chữ cái đầu như cũ.
 */
const AvatarSrcContext = createContext<(seed: string) => string | undefined>(() => undefined);
export const AvatarSrcProvider = AvatarSrcContext.Provider;

export function Avatar({
  name,
  seed,
  size = 'md',
  src,
}: {
  name: string;
  seed?: string;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  /** Ảnh WebP base64url chỉ định trực tiếp (ví dụ xem trước); không có thì tra theo `seed`. */
  src?: string | null;
}) {
  const lookup = useContext(AvatarSrcContext);
  const image = src ?? (seed ? lookup(seed) : undefined);
  return (
    <span className={`ws-avatar ws-avatar-${size} ws-tone-${avatarTone(seed ?? name)}${image ? ' has-image' : ''}`} aria-hidden="true">
      {image ? <img src={avatarDataUrl(image)} alt="" draggable={false} /> : initials(name) || '?'}
    </span>
  );
}
